import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page introuvable — Four A Tacos';
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
      <Header />

      <div style={{ marginTop: '80px' }}>
        <div className="hero-banner" style={{ backgroundColor: '#C10230' }}>
          <h1 className="hero-title">404</h1>
        </div>
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
        <h2 className="notfound-title" style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '52px', color: '#C10230', margin: '0 0 16px 0', lineHeight: 1.1, textTransform: 'uppercase', letterSpacing: '2px' }}>
          Oups…<br />Cette page est introuvable
        </h2>

        <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '16px', color: '#666', margin: '0 0 40px 0' }}>
          Il semble que la page que vous cherchez n'existe pas.
        </p>

        <Link
          to="/"
          style={{ backgroundColor: '#C10230', color: '#fff', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '700', padding: '14px 36px', borderRadius: '10px', textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '1px' }}
        >
          Retour à l'accueil
        </Link>
      </div>

      <Footer />
    </div>
  );
}
